import * as React from 'react';
import { Button, Tabs, Col, Row, Collapse } from 'antd';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { HeaderView } from 'src/app/shared/header.view';
import { PublicEventsEditorView } from 'src/app/rules/rules/parts/public-events-editor.view';
import { CardController } from 'src/app/shared/card.controller';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { RulesConditionEditorView } from 'src/app/rules/rules/parts/rules-conditions.editor';
import { RulesExecutorEditorView } from 'src/app/rules/rules/parts/rules-executors';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { DateView } from 'src/core/ui/date.view';
import { DisableKind } from 'src/core/ui/timepicker.view';
import { CronBuilder } from 'src/app/rules/rules/form/parts/cron-builder';
import { IStackTraceMessage } from 'src/app/rules/rules/rule-services';
import { ContextService } from 'src/core/services/context.service';
import { ZuluIcon } from 'src/app/shared/icon';
import { IScheduledEventEventName, IRecurrentEventEventName } from 'src/app/rules/rules/parts/conditions';

const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;

interface RulesFormViewProps extends ComponentViewProps<RuleItem> {
	title?: string,
	save?: () => void,
	cancel?: () => void,
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	reloadEvents: () => void;
	contextService: ContextService;
	event?: PublicEventItem;
	runManually: () => Promise<IStackTraceMessage>;
	runManuallyEnabled: boolean;
}

interface IRulesFormViewState {
	event?: PublicEventItem,
	eventName: string,
	wrapperName: string,
	executionMessage?: IStackTraceMessage;
	openTraceModal: boolean;
}

@observer
export class RulesFormView extends React.Component<RulesFormViewProps, IRulesFormViewState> {
	constructor(props: any) {
		super(props);

		this.state = {
			event: null, eventName: this.props.model.eventTypeFullName,
			wrapperName: this.props.model.eventWrapperName,
			openTraceModal: false
		}
	}

	private scheduleEvent: PublicEventItem = {
		classPath: IScheduledEventEventName,
		description: 'Execute rule at date',
		displayName: 'Scheduled Event',
		mapPath: IScheduledEventEventName,
		properties: [
		]
	};


	private recurrentEvent: PublicEventItem = {
		classPath: IRecurrentEventEventName,
		description: 'Execute rule every time lapse',
		displayName: 'Recurrent Event',
		mapPath: IRecurrentEventEventName,
		properties: [

		]
	};

	@autobind
	private runManually() {
		this.props.runManually().then(result => {
			// this.setState({ executionMessage: result, openTraceModal: true });
		})
			.catch(err => {
				// this.setState({ executionMessage: undefined, openTraceModal: false })
			});
	}

	public componentDidMount() {
		this.setState({ event: this.props.event });
	}

	public componentWillReceiveProps(nextProps: RulesFormViewProps) {
		if (nextProps.event != this.props.event) {
			this.setState({ event: nextProps.event });
		}
	}

	private renderDefinitions() {
		const { model, mode } = this.props;
		const body = this.props.model.dynamicProperties as RuleBody;


		return (<Collapse>
			<Panel header='Rule conditions' key='conditions'>


				<p>The rules conditions will be executed in the same order of the visible tabs</p>
				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignContent: 'center', alignItems: 'center' }}>
					<Button disabled={this.props.mode == 'display'} style={{ margin: '10px', alignSelf: 'center' }} icon='plus' type='primary' onClick={() => { body.conditions = [...body.conditions, { name: 'Unsetted', conditionDefinitionType: '', conditionValues: {} }] }}>Add condition</Button>

					<p style={{ alignSelf: 'center' }}>Execute rule if</p>
					<div style={{ width: '70px', margin: '5px', alignSelf: 'center' }}>
						<DropdownView
							label=''
							model={body.policy}
							required={true}
							disabled={this.props.mode == 'display'}
							onChanged={(e) => body.policy = e.value}
							options={[{ value: 0, text: 'All' }, { value: 1, text: 'Any' }]}
							keyField='value'
							textField='text'
						/>
					</div>

					<p style={{ alignSelf: 'center' }}>condition returns true</p>

				</div>


				<Tabs>
					{body.conditions.map((item, index) => {
						return (<TabPane key={"condTab_" + index} tab={<p>{item.name}
							<ZuluIcon style={{ marginLeft: '10px', cursor: 'pointer' }} type='close'
								onClick={() => {

									if (this.props.mode == 'edit') {
										const index = body.conditions.indexOf(item);

										body.conditions.splice(index, 1);

										body.conditions = [...body.conditions];
									}
								}}
							/></p>}>
							<RulesConditionEditorView
								label=''
								wrapperName={this.state.wrapperName}
								onChanged={(e) => {
									item.name = e.name;
									item.conditionDefinitionType = e.classPath;

									item.conditionValues = {};
								}}
								onFieldChange={this.handleFieldChange(item)}
								eventClasspath={this.state.eventName}
								event={this.state.event}
								value={item}
								mode={this.props.mode}
								setBusy={this.props.setBusy}
							/>
						</TabPane>);
					})}
				</Tabs>

			</Panel>

			<Panel header='Rule main executors' key='executors'>

				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignContent: 'center', alignItems: 'center' }}>
					<Button
						disabled={this.props.mode == 'display'}
						style={{ margin: '10px', alignSelf: 'center' }}
						icon='plus' type='primary'
						onClick={() => { body.branchExecutors = [...body.branchExecutors, { name: 'Unsetted', conditionDefinitionType: '', conditionValues: {} }] }}>Add Executor</Button>

				</div>


				<Tabs>
					{body.branchExecutors.map((item, index) => {
						return (<TabPane key={"exTab_" + index} tab={<p>{item.name}
							<ZuluIcon style={{ marginLeft: '10px', cursor: 'pointer' }} type='close'
								onClick={() => {

									if (this.props.mode == 'edit') {
										const index = body.branchExecutors.indexOf(item);

										body.branchExecutors.splice(index, 1);

										body.branchExecutors = [...body.branchExecutors];
									}
								}}
							/></p>}>
							<RulesExecutorEditorView
								label=''
								eventWrapperName={this.state.wrapperName}
								onChanged={(e) => {
									item.name = e.name;
									item.conditionDefinitionType = e.classPath;
									item.conditionValues = {};
								}}
								onFieldChange={this.handleFieldChange(item)}
								eventClasspath={this.state.eventName}
								event={this.state.event}
								value={item}
								mode={this.props.mode}
								setBusy={this.props.setBusy}
							/>
						</TabPane>);
					})}
				</Tabs>
			</Panel>

			<Panel header='Rule alternative executors' key='alternative'>

				<div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignContent: 'center', alignItems: 'center' }}>
					<Button
						disabled={this.props.mode == 'display'}
						style={{ margin: '10px', alignSelf: 'center' }}
						icon='plus' type='primary'
						onClick={() => { body.alternativeExecutors = [...body.alternativeExecutors, { name: 'Unsetted', conditionDefinitionType: '', conditionValues: {} }] }}>Add Executor</Button>

				</div>


				<Tabs>
					{body.alternativeExecutors.map((item, index) => {
						return (<TabPane key={"exTab_" + index} tab={<p>{item.name}
							<ZuluIcon style={{ marginLeft: '10px', cursor: 'pointer' }} type='close'
								onClick={() => {

									if (this.props.mode == 'edit') {
										const index = body.alternativeExecutors.indexOf(item);

										body.alternativeExecutors.splice(index, 1);

										body.alternativeExecutors = [...body.alternativeExecutors];
									}
								}}
							/></p>}>
							<RulesExecutorEditorView
								label=''

								eventWrapperName={this.state.wrapperName}
								onChanged={(e) => {
									item.name = e.name;
									item.conditionDefinitionType = e.classPath;
									item.conditionValues = {};

								}}
								onFieldChange={this.handleFieldChange(item)}
								eventClasspath={this.state.eventName}
								event={this.state.event}
								value={item}
								mode={this.props.mode}
								setBusy={this.props.setBusy}
							/>
						</TabPane>);
					})}
				</Tabs>
			</Panel>
		</Collapse>);
	}

	public render() {
		const { model, mode } = this.props;
		const body = this.props.model.dynamicProperties as RuleBody;

		return <div className="window window-normal">
			<Row>
				<Col xs={24}>

					<Row>
						<Col xs={24}>
							<HeaderView
								contextService={this.props.contextService}
								title={this.props.title}
								mode={this.props.mode}
								onModeChanged={this.props.onModeChanged}
								save={this.props.save}
								cancel={this.props.cancel}
							/>
						</Col>
					</Row>
					<CardController
						mode={this.props.mode}
						icon="book"
						title="Rule configuration">
						<Row gutter={24}>
							<Col xs={24} lg={16}>

								<div>
									<DropdownView
										label='Execution mode'
										required={true}
										onGetErrorMessage={() => this.props.model.validate(false, 'mode')}
										disabled={this.props.mode == 'display'}
										onChanged={(e) => {
											model.mode = e ? e.value : null;

											model.dynamicProperties.conditions = [];
											model.dynamicProperties.branchExecutors = [];
											model.dynamicProperties.alternativeExecutors = [];

											if (e.value == 1) {
												model.eventTypeFullName = this.scheduleEvent.classPath;
												model.eventName = this.scheduleEvent.classPath;;
												model.eventWrapperName = this.scheduleEvent.classPath;;


												this.setState({
													event: this.scheduleEvent,
													eventName: model.eventName, wrapperName: model.eventWrapperName
												});
											}
											else if (e.value == 2) {
												model.eventTypeFullName = this.recurrentEvent.classPath;
												model.eventName = this.recurrentEvent.classPath;;
												model.eventWrapperName = this.recurrentEvent.classPath;;


												this.setState({
													event: this.recurrentEvent,
													eventName: model.eventName, wrapperName: model.eventWrapperName
												});
											}
											else {
												model.executionDeadline = null;
												model.executionTimeSpan = null;

												model.eventTypeFullName = null;
												model.eventName = null;
												model.eventWrapperName = null;


												this.setState({
													event: null, eventName: this.props.model.eventTypeFullName,
													wrapperName: this.props.model.eventWrapperName
												});
											}

										}}

										model={model.mode}
										options={[
											{ value: 0, label: 'On entity change' },
											{ value: 1, label: 'Scheduled' },
											{ value: 2, label: 'Recurrent' }]}
									/>
									{
										(model.mode === 1 || model.mode == 2) &&

										<Button disabled={!this.props.runManuallyEnabled} onClick={this.runManually}>Run manually</Button>
									}
								</div>

								{model.mode === 0 && /*On entity change event*/ <PublicEventsEditorView
									required={true}
									mode={mode}
									value={model.eventWrapperName}
									label='On entity change'
									onChanged={(e) => {
										model.eventTypeFullName = e.mapPath;
										model.eventName = e.mapPath;
										model.eventWrapperName = e.classPath;

										model.dynamicProperties.conditions = [];
										model.dynamicProperties.branchExecutors = [];
										model.dynamicProperties.alternativeExecutors = [];

										this.setState({ event: e, eventName: e.mapPath, wrapperName: e.classPath });
									}
									}
								/>}

								{model.mode === 1 && /* Scheduled execution */
									<DateView
										mode={this.props.mode}
										label='Execute at'
										showTime={DisableKind.disableSeconds}
										value={model.executionDeadline}
										format={'date-time'}
										onChanged={(e) => {

											model.executionDeadline = e;
										}
										}
									/>
								}
								{model.mode === 2 &&
									<CronBuilder
										mode={this.props.mode}
										cronScript={model.executionTimeSpan}
										onChanged={e => model.executionTimeSpan = e}
									/>
								}

							</Col>
							<Col xs={24} lg={8}>

								<TextView
									mode={mode}
									label="Rule name"
									required
									value={model.name}
									onChanged={newVal => {
										model.name = newVal;
									}}
								/>

								<BooleanView label='Is active'
									onChanged={(e) => model.isActive = e}
									mode={mode} value={model.isActive} />

								<TextView
									mode={mode}
									label="Rule description"

									rows={5}
									value={model.description}
									onChanged={newVal => {
										model.description = newVal;
									}}
								/>

							</Col>

						</Row>


					</CardController>
				</Col>
			</Row>
			<Row>

				{this.state.wrapperName && this.renderDefinitions()}

			</Row>
		</div>
	}

	private handleFieldChange = (item) => (name, value) => {
		if (item.conditionValues[name] != value) {
			item.conditionValues[name] = value;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/rules-form.view.tsx